import React from "react";
import { X } from "lucide-react";
import { Dialog } from "./Dialog";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import { sanitizeTermsHtml } from "../utils/sanitizeTermsHtml";

interface TermsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  bodyHtml: string;
}

export const TermsDialog: React.FC<TermsDialogProps> = ({
  isOpen,
  onClose,
  title,
  bodyHtml,
}) => {
  const { t } = useTranslation();
  const sanitizedHtml = sanitizeTermsHtml(bodyHtml);

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div
        className="flex flex-col gap-4 p-6"
        role="document"
        aria-labelledby="terms-dialog-title"
      >
        <div className="flex items-center justify-between">
          <h2 id="terms-dialog-title" className="text-xl font-semibold">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-ink-secondary hover:text-ink/80"
            aria-label="Close dialog"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div
          className="prose prose-sm max-h-[70vh] max-w-none overflow-y-auto px-4"
          dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />

        <div className="mt-4 flex justify-end">
          <Button
            type="button"
            onClick={onClose}
            className="rounded-md px-4 py-2 text-on-primary"
            aria-label="Close Terms Dialog"
          >
            {t("common.close")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
